import React, { useState } from 'react';
import NorthIndianChart from './NorthIndianChart';
import SouthIndianChart from './SouthIndianChart';

// Chart wrapper with North/South Indian toggle
const ChartToggle = ({ 
  planets = {},
  houseSignMap = {},
  ascendantSign = 'Leo',
  size = 320,
  title = '',
  showDegrees = false,
  defaultStyle = 'north'
}) => {
  const [chartStyle, setChartStyle] = useState(defaultStyle);

  return (
    <div className="flex flex-col items-center">
      {/* Toggle buttons */}
      <div className="flex gap-2 mb-3">
        <button
          onClick={() => setChartStyle('north')}
          className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-all ${
            chartStyle === 'north'
              ? 'bg-amber-500 text-black'
              : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
          }`}
        >
          North Indian
        </button>
        <button
          onClick={() => setChartStyle('south')}
          className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-all ${
            chartStyle === 'south'
              ? 'bg-amber-500 text-black'
              : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
          }`}
        >
          South Indian
        </button>
      </div>

      {/* Chart display */}
      {chartStyle === 'north' ? (
        <NorthIndianChart
          planets={planets}
          houseSignMap={houseSignMap}
          size={size}
          title={title}
          showDegrees={showDegrees}
        />
      ) : (
        <SouthIndianChart
          planets={planets}
          houseSignMap={houseSignMap}
          ascendantSign={ascendantSign}
          size={size}
          title={title}
          showDegrees={showDegrees}
        />
      )}
    </div>
  );
};

export default ChartToggle;
